//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'App',
  data() {
    return {
      verifyStatus: '',
      error: '',
    };
  },
  head() {
    return {
      title: 'STEP1NE 註冊驗證 - 確認您的電子郵件',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'STEP1NE 註冊驗證 - 確保您的帳戶安全',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '完成您在STEP1NE的註冊過程。請使用您收到的電子郵件中的鏈接來驗證您的帳戶，確保註冊流程的順利完成。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            '完成您在STEP1NE的註冊過程。請使用您收到的電子郵件中的鏈接來驗證您的帳戶，確保註冊流程的順利完成。',
        },
      ],
    };
  },
  methods: {
    onClickBackHome() {
      this.$router.replace('/');
    },
  },
  mounted() {
    if (process.client) {
      const query = this.$route.query;
      let payload = {
        ...query,
      };
      this.$api('authVerify', payload)
        .then(() => {
          this.verifyStatus = 'success';
        })
        .catch(error => {
          this.verifyStatus = 'fail';
          this.error = error;
        });
    }
  },
};
